import { Button, IconButton, Pagination, Stack, TextField, Tooltip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import Container from 'src/components/container/Container'
import CustomTable from 'src/components/CustomTable';
import { useSettingsContext } from 'src/components/settings';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router';
import getStaffs from 'src/services/staffs/getStaffs';
import { useAuthContext } from 'src/auth/useAuthContext';
import EditIcon from '@mui/icons-material/Edit';
import { debounce } from 'lodash';
import { convertWebFormateTime2 } from 'src/functions';
export default function StaffsPage() {
  const { themeStretch } = useSettingsContext();
  const { user, logout } = useAuthContext()
  const navigate = useNavigate()
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(0)
  const staffColums = [
    {
      id: "SI No",
      label: "SI No",
      renderCell: (_, index) => {
        return index + 1;
      },
    },
    {
      id: "name",
      label: "Name",
      renderCell: (rowData) => {
        return rowData?.partner?.name || '-'
      },
    },
    {
      id: "Email",
      label: "Email",
      renderCell: (rowData) => {
        return rowData?.partner?.email || '-'
      },
    },
    {
      id: "Mobile Number",
      label: "Mobile Number",
      renderCell: (rowData) => {
        return rowData?.partner?.mobile || "-"
      },
    },
    {
      id: "Role",
      label: "Role",
      renderCell: (rowData) => {
        return rowData?.sub_role?.name || "-"
      },
    },
    {
      id: "Status",
      label: "Status",
      renderCell: (rowData) => {
        return rowData?.employee_status == "pending" ? "Pending" : rowData?.employee_status == "active" ? "Active" : "Terminated"
      },
    },
    {
      id: "Created/ Edited at",
      label: "Created",
      renderCell: (rowData) => {
        return rowData?.updatedAt ? dayjs(rowData?.updatedAt).format("DD/MM/YYYY hh:mm A") : "-"
      },
    },
    {
      id: "Actions",
      label: "Actions",
      renderCell: (rowData) => {
        return (
          <>
            <IconButton
              onClick={() => {
                navigate('create/', { state: rowData })
              }}
              disabled={rowData?.sub_role?.name == "Admin"}
            >
              <EditIcon />
            </IconButton>

          </>
        );
      },
    },
  ];
  const [staffsData, setStaffsData] = useState([])
  const [search, setSearch] = useState()
  useEffect(() => {
    const fetchData = async () => {
      const { data } = await getStaffs(user, logout, search, page)
      setStaffsData(data?._payload || [])
      setTotalPages(data?.totalPages)

    }
    fetchData()
  }, [search, page])
  const handleChange = (event, value) => {
    setPage(value - 1);
  };
  const handleSearch = debounce((e) => {
    setPage(0)
    setSearch(e.target.value)
  }, 800)
  return (
    <div>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <Stack
          direction="row"
          sx={{ justifyContent: 'space-between', mb: 2 }}
          alignContent="center"
        >
          <Stack direction="row" alignItems="center" gap="10px">
            <Typography variant="h4" color="primary">
              Staffs
            </Typography>
            <TextField fullWidth placeholder='Search...' onChange={handleSearch} size="small" />
          </Stack>
          <Button variant="contained" onClick={() => navigate('create')}>
            Create Staff
          </Button>
        </Stack>
        <CustomTable columns={staffColums} rows={staffsData} />
        <Stack sx={{ width: '100%', p: 3 }} alignItems="center" justifyContent="center">
          <Pagination count={totalPages} page={page + 1} color="primary" onChange={handleChange} />
        </Stack>
      </Container>
    </div>
  )
}
